import React from 'react';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { ALERT_SIZE, HcpAlert, SEVERITY } from '@hmhco/hcp-alert';
import useStyles from './EarlyAccessPageHeading.styles';
import {
  getIsEarlyAccessSubmitDisabled,
  getEarlyAccessShouldRenderErrorScreen,
  getEarlyAccessShouldRenderSuccessScreen,
} from '../../../../store/selectors/EarlyAccessPageState';
import RequiredFieldsNote from '../../RequiredFieldsNote/RequiredFieldsNote';

const getTitleId = renderSuccessState => {
  if (renderSuccessState) {
    return 'earlyAccess.successTitle';
  }
  return 'earlyAccess.title';
};

const EarlyAccessPageHeading = () => {
  const { cx, classes } = useStyles();
  const { formatMessage } = useIntl();
  const isSubmitDisabled = useSelector(getIsEarlyAccessSubmitDisabled);
  const renderErrorState = useSelector(getEarlyAccessShouldRenderErrorScreen);
  const renderSuccessState = useSelector(
    getEarlyAccessShouldRenderSuccessScreen,
  );
  const titleId = getTitleId(renderSuccessState);

  return (
    <div className={classes.root}>
      <div
        className={cx(classes.errors, {
          [classes.hasError]: renderErrorState || isSubmitDisabled,
        })}
      >
        {renderErrorState && (
          <HcpAlert
            size={ALERT_SIZE.SMALL}
            severity={SEVERITY.ERROR}
            title={formatMessage({
              id: 'tenantPicker.errorTitle',
            })}
            subtitle={formatMessage({
              id: 'earlyAccess.magicLink.error',
            })}
            action={null}
          />
        )}
      </div>
      <Typography component="h1" variant="h3">
        <FormattedMessage id={titleId} />
      </Typography>
      {!renderSuccessState && !renderErrorState && <RequiredFieldsNote />}
    </div>
  );
};

export default EarlyAccessPageHeading;
